import { useContext, useEffect, useState } from 'react';
import { RemotionPlayerContext } from '../context/RemotionPlayerContext';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { roundToNDecimalPlaces } from '@/player-config/src/utils/mathUtils';

/**
 * You can use this when there is more than one clip that is being used within the same page
 * This will pick time from within Current ClipContext
 * But if there is only one clip, you may want to choose to use useRemotionPlayerCurrentTime
 */
export const useRemotionPlayerCurrentTimeFromContext = () => {
  const { playerRef } = useContext(RemotionPlayerContext);

  const { fps } = useClipsContext();

  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (playerRef) {
      const handleTimeUpdate = ({ detail: { frame } }: { detail: { frame: number } }) => {
        setCurrentTime(roundToNDecimalPlaces(frame / fps, 3));
      };
      playerRef.addEventListener('timeupdate', handleTimeUpdate);
      setCurrentTime(roundToNDecimalPlaces(playerRef.getCurrentFrame() / fps, 3));
      return () => {
        playerRef.removeEventListener('timeupdate', handleTimeUpdate);
      };
    }
  }, [playerRef, fps]);

  return {
    currentTime
  };
};
